import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import { withRouter } from 'next/router';
import { graphql, compose } from 'react-apollo';
import Link from 'next/link';
import config from "../../utils/clientConfig";
import { queries } from "../../data/queries";
import { Container, Icon, ClickedOutside } from "../_global";
import Search from "../Search";
import CategoryMenu from "./CategoryMenu";
import ChatBoxButton from "../ChatBox/Button";
import { NavWrapper, MobileNavWrapper, NavBarContainer, NavItemList, NavItem, SearchContainer, MenuButton, MobileGlobalNav, Desktop, Mobile, ChatContainer } from "./style";
import { topNavItemsType, categoriesType } from "../../constants/app";
import createUniversalNavScript from "../../utils/createUniversalNavScript";
var DesktopNavbar = /*#__PURE__*/function (_Component) {
  function DesktopNavbar(props) {
    var _this;
    _classCallCheck(this, DesktopNavbar);
    _this = _callSuper(this, DesktopNavbar, [props]);
    _this.routeChangeCompleteCb = function () {
      _this.setState({
        showDesktopCatMenu: false
      });
    };
    _this.globalClickHandler = function (event) {
      var target = event.target;
      var navigatableLink = target.dataset && target.dataset.final === 'true';
      if (navigatableLink) {
        _this.setState({
          showMobileNav: false,
          showMobileCatMenu: false,
          showDesktopCatMenu: false
        });
      }
    };
    _this.closeMobileMenu = function () {
      _this.setState({
        showMobileNav: false
      });
    };
    _this.toggleMobileMenu = function () {
      _this.setState({
        showMobileNav: !_this.state.showMobileNav
      });
    };
    _this.toggleMobileCategoryMenu = function () {
      _this.setState({
        showMobileCatMenu: !_this.state.showMobileCatMenu
      });
    };
    _this.openDesktopCategoryMenu = function () {
      _this.setState({
        showDesktopCatMenu: !_this.state.showDesktopCatMenu
      });
    };
    _this.closeDesktopCategoryMenu = function () {
      _this.setState({
        showDesktopCatMenu: false
      });
    };
    _this.renderNavItems = function (pathname, navItems) {
      return (navItems || []).map(function (item, i) {
        return __jsx(NavItem, {
          key: i,
          active: item.href === pathname,
          backgroundColor: item.backgroundColor
        }, __jsx(Link, {
          href: item.href
        }, __jsx("a", {
          "data-final": true
        }, item.title)));
      });
    };
    _this.renderMobileGlobalNav = function () {
      return __jsx("div", {
        "data-widget-type": "global_features_navigation",
        className: "".concat(_this.props.showGlobalNav ? '' : 'sr-only', " global_features_mobile")
      }, __jsx("script", {
        defer: true,
        type: "qantas/widget",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(config.UNIVERSAL)
        }
      }));
    };
    _this.state = {
      showMobileNav: false,
      showMobileCatMenu: false,
      showDesktopCatMenu: false
    };
    _this.script = null;
    return _this;
  }
  _inherits(DesktopNavbar, _Component);
  return _createClass(DesktopNavbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      createUniversalNavScript();
      document.addEventListener('click', this.globalClickHandler, false);
      this.props.router.events.on('routeChangeComplete', this.routeChangeCompleteCb);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.globalClickHandler, false);
      this.props.router.events.off('routeChangeComplete', this.routeChangeCompleteCb);
    }

    /* eslint-disable react/no-danger */
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        loading = _this$props.loading,
        showGlobalNav = _this$props.showGlobalNav,
        router = _this$props.router,
        categories = _this$props.categories,
        topNavItems = _this$props.topNavItems;
      var _this$state = this.state,
        showDesktopCatMenu = _this$state.showDesktopCatMenu,
        showMobileNav = _this$state.showMobileNav,
        showMobileCatMenu = _this$state.showMobileCatMenu;
      var navItems = [{
        title: 'All Stores A - Z',
        href: '/all-stores'
      }, {
        title: 'Card Offers',
        href: '/card-offers'
      }, {
        title: 'Shopping history',
        href: '/shopping-history'
      }, {
        title: 'How it works',
        href: '/how-it-works'
      }].concat(topNavItems.map(function (i) {
        return {
          title: i.displayName,
          href: "/".concat(i.url),
          backgroundColor: i.backgroundColor && i.backgroundColor !== '' ? i.backgroundColor : '#8d8d66'
        };
      }));
      if (loading) {
        return __jsx(Container, null, "Loading");
      }
      if (error && error.message) {
        return __jsx(Container, null, "Error");
      }
      return __jsx(NavWrapper, null, __jsx(Desktop, null, __jsx(NavBarContainer, {
        veryWideView: true
      }, __jsx(NavItemList, null, __jsx(NavItem, {
        onMouseEnter: this.openDesktopCategoryMenu,
        onMouseLeave: this.closeDesktopCategoryMenu,
        showDesktopCatMenu: showDesktopCatMenu,
        tabIndex: "0",
        role: "button",
        "aria-pressed": "false",
        onKeyPress: this.openDesktopCategoryMenu
      }, __jsx("a", null, "Categories", __jsx(Icon, {
        iconType: "caretDown"
      })), __jsx(CategoryMenu, {
        categories: categories
      })), this.renderNavItems(router.asPath, navItems)), __jsx(SearchContainer, null, __jsx(Search, {
        isMobile: false
      })))), __jsx(Mobile, null, __jsx(NavBarContainer, {
        wideView: true
      }, __jsx(MenuButton, {
        className: "ignore-react-onclickoutside",
        onClick: this.toggleMobileMenu,
        primary: true
      }, "Menu"), __jsx(SearchContainer, null, __jsx(Search, null)), __jsx(ClickedOutside, {
        handleClickOutside: this.closeMobileMenu
      }, __jsx(MobileNavWrapper, {
        showMobile: showMobileNav
      }, __jsx(NavItemList, null, __jsx(NavItem, {
        onClick: this.toggleMobileCategoryMenu,
        showMobileCatMenu: showMobileCatMenu
      }, __jsx("a", null, "Categories"), __jsx(CategoryMenu, {
        categories: categories,
        mobile: true
      })), this.renderNavItems(router.pathname, navItems), showGlobalNav && __jsx(NavItem, {
        isGlobalNav: true
      }, __jsx(MobileGlobalNav, null, "Explore more from Qantas")), this.renderMobileGlobalNav()))))));
    }
  }]);
}(Component);
DesktopNavbar.defaultProps = {
  categories: [],
  loading: true,
  error: {},
  showGlobalNav: true,
  router: {},
  topNavItems: []
};
export default withRouter(compose(graphql(queries.getCategory, {
  props: function props(_ref) {
    var data = _ref.data;
    return data;
  }
}))(DesktopNavbar));